import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
require("dayjs/locale/pt");

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.locale("pt");

export function formatDate(value, formatString = "DD/MM/YYYY HH:mm:ss") {
  if (!value) return "";

  const date = new Date(value.toString());
  return dayjs(date).format(formatString);
}

export function currentDate(formatString = "DD/MM/YYYY HH:mm:ss") {
  const date = new Date();
  return dayjs(date).format(formatString);
}

export function formatTimezoneDate(
  value,
  formatString = "DD/MM/YYYY HH:mm:ss",
  timezone = "America/Sao_Paulo"
) {
  if (!value) return "";

  const date = new Date(value.toString());
  return dayjs(date).tz(timezone).format(formatString);
}

export function revertTimestamp(value, format = "DD/MM/YYYY HH:mm:ss") {
  if (!value) return "";

  return dayjs(value).format(format);
}

export function diffDates(start, end) {
  if (!start || !end) return "";

  const date1 = dayjs(start);
  const date2 = dayjs(end);

  const diff = date1.diff(date2);

  return dayjs.duration(diff).format("HH:mm:ss");
}
